function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 100%;\n  background-image: url(",
        "), url(",
        ");\n  background-position: top left, bottom right;\n  background-size: auto 75%;\n  background-repeat: no-repeat;\n  width: 100%;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  display: block;\n  width: 250px;\n  margin-bottom: 20px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  border-radius: 10px;\n  @media (max-width: 600px) {\n    border-radius: unset;\n  }\n  .ant-card-body {\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    width: 500px;\n    @media (max-width: 600px) {\n      width: 100vw;\n      height: 100vh;\n      min-height: 600px;\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  top: -32px;\n  right: 0;\n  min-width: 135px;\n  color: white;\n  .ant-select-selection-item {\n    height: 26px;\n    text-align: right;\n  }\n  .ant-select-selection-search {\n    margin-left: 0;\n  }\n  .ant-select-arrow {\n    color: inherit;\n  }\n\n  @media (max-width: 600px) {\n    top: 0;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n  font-size: 12px;\n  margin-top: 24px;\n  color: #595959;\n\n  @media (max-width: 600px) {\n    padding: 15px;\n    flex: 1;\n    align-items: flex-end;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n\n  @media (max-width: 600px) {\n    margin-top: 50px;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  border-left: 1px solid #686868;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "Language"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "Terms of Use"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "Privacy Policy"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "Powered by ",
        "™"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
import React from "react";
import styled from "styled-components";
import { Card as AntCard, Divider as AntDivider, Select as AntSelect, Space } from "antd";
import { t, jt } from "ttag";
import BGTopLeft from "../../assets/login-bg-top-left.png";
import BGBottomRight from "../../assets/login-bg-bottom-right.png";
import LogoImage from "../../assets/EM-logo-colour-dark.svg";
import useTranslation from "../../hooks/useTranslation";
import { ISO_LOCALE_MAP, LANGUAGE_BY_ISO } from "../../services/translation/api";
export var Background = styled.div(_templateObject(), BGTopLeft, BGBottomRight);
var Logo = styled.img(_templateObject1());
var Card = styled(AntCard)(_templateObject2());
var Select = styled(AntSelect)(_templateObject3());
var Footer = styled.div(_templateObject4());
var Content = styled.div(_templateObject5());
var Divider = styled(AntDivider)(_templateObject6());
var Layout = function(param) {
    var children = param.children;
    var _useTranslation = useTranslation(), language = _useTranslation.language, setLanguage = _useTranslation.setLanguage;
    var EMLink = /*#__PURE__*/ React.createElement("a", {
        key: "em",
        href: "https://eventmobi.com",
        rel: "nofollow noopener noreferrer",
        target: "_blank"
    }, "EventMobi");
    return /*#__PURE__*/ React.createElement(Background, null, /*#__PURE__*/ React.createElement(Card, null, /*#__PURE__*/ React.createElement(Select, {
        bordered: false,
        placeholder: t(_templateObject7()),
        value: language,
        onChange: function(lang) {
            return setLanguage(lang);
        },
        style: {
            color: "#595959"
        },
        options: Object.keys(ISO_LOCALE_MAP).map(function(code) {
            return {
                value: code,
                label: LANGUAGE_BY_ISO(code)
            };
        })
    }), /*#__PURE__*/ React.createElement(Logo, {
        src: LogoImage,
        alt: "EventMobi"
    }), /*#__PURE__*/ React.createElement(Content, null, children), /*#__PURE__*/ React.createElement(Footer, null, /*#__PURE__*/ React.createElement(Space, {
        split: /*#__PURE__*/ React.createElement(Divider, {
            type: "vertical"
        })
    }, /*#__PURE__*/ React.createElement("a", {
        href: "https://eventmobi.com/terms-of-use/",
        rel: "nofollow noopener noreferrer",
        target: "_blank"
    }, t(_templateObject8())), /*#__PURE__*/ React.createElement("a", {
        href: "https://eventmobi.com/privacy-policy/",
        rel: "nofollow noopener noreferrer",
        target: "_blank"
    }, t(_templateObject9()))), /*#__PURE__*/ React.createElement("div", null, jt(_templateObject10(), EMLink)))));
};
export default Layout;
